import { useEffect } from 'react';
import ChatRoomLayout from '@/components/layouts/chatroom-layout';
import useSessionEffect from '@/hooks/conversations/use-session-effect';
import useGroupInfo from '@/hooks/groups/use-group-info';
import useGroupSocketEvents from '@/hooks/groups/use-group-socket-events';
import { ConversationMessageContentType } from '@/models/conversations/conversation';
import { useLayoutStore } from '@/stores/layout-status';
import { useMessageStore } from '@/stores/message';
import { parseSessionKey } from '@/utils/session';

export default function GroupMessagesLayout() {
  const id = useLayoutStore((s) => parseSessionKey(s.sessionKey ?? '')[1]);

  useSessionEffect('group', id);
  useGroupSocketEvents(id);
  const { canManage } = useGroupInfo(id);

  useEffect(() => {
    useMessageStore
      .getState()
      .setExcludeTypes(canManage ? undefined : new Set([ConversationMessageContentType.LeaveGroup]));
  }, [canManage]);

  return <ChatRoomLayout type='group' />;
}
